export default function productsReducer(state = [], { type, payload }) {
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/cart-reducer.js